import {connect} from 'react-redux';

import BaseURLChanger from '../../general/components/URLChanger';

const mapStateToProps = (state, {buildURL}) => {
    const {language, regionID, locationID, offset, startHour, resolution, showFavouritesOnly} = state;

    return {
        url: buildURL(state),
        data: {
            language,
            regionID,
            locationID,
            offset,
            startHour,
            resolution,
            showFavouritesOnly,
        },
    };
};

export default connect(mapStateToProps)(BaseURLChanger);
